import { trackEvent as track, trackPageview as trackPage } from "./plausibleClient";
import { AnalyticsEvents, StandardProps } from "./analyticsEvents";
import type { AnalyticsEventName, EventProperties } from "./analyticsEvents";

/**
 * Vue composable for analytics tracking.
 *
 * Provides easy access to event tracking and standard property names.
 *
 * @example
 * <script setup lang="ts">
 * import { useAnalytics } from '@/Common/Analytics/useAnalytics';
 *
 * const { trackEvent, events, props } = useAnalytics();
 *
 * function handleSignup() {
 *   // ... signup logic
 *   trackEvent(events.Signup.Completed, { [props.METHOD]: 'email' });
 * }
 * </script>
 */
export function useAnalytics() {
    /**
     * Track an analytics event.
     */
    const trackEvent = (event: AnalyticsEventName, properties?: EventProperties) => {
        track(event, properties);
    };

    /**
     * Track a pageview (for SPA navigation).
     */
    const trackPageview = () => {
        trackPage();
    };

    return {
        trackEvent,
        trackPageview,
        events: AnalyticsEvents,
        props: StandardProps,
    };
}
